module.exports = __webpack_public_path__ + "static/img/82-1.4384417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/82-1.jpg
// module id = TtX4
// module chunks = 0